import {
  CrimeReference,
  CrimeReferenceReceptionMethod,
  Evidence,
  Exhibit,
} from "types";
import apiClient from "../lib/apiClients";

export const fetchCrimeReferences = async () => {
  const response = await apiClient.get<CrimeReference[]>(
    "/crime-reference/crime-references/"
  );
  return response.data;
};
export const fetchCrimeReferenceReceptionMethod = async () => {
  const response = await apiClient.get<CrimeReferenceReceptionMethod[]>(
    "/crime-reference/reception-methods/"
  );
  return response.data;
};
export const addCrimeReferences = async (incident: CrimeReference) => {
  const response = await apiClient.post("/crime-reference/crime-references/", {
    ...incident,
    reception_method_id: incident.reception_method,
    status: incident.status?.toString().toLowerCase(),
    crime_type: incident.crime_type?.toString().toLowerCase(),
    crime_incidence_time: incident.crime_incidence_time
      ? new Date(incident.crime_incidence_time)
      : null,
    screening_outcome: "rejected",
    decision_type: "close_case",
  });
  return response.data;
};

// EVIDENCE
export const fetchEvidence = async () => {
  const response = await apiClient.get<Evidence[]>(
    "/crime-reference/evidences/"
  );
  return response.data;
};
export const addEvidence = async (evidence: Evidence) => {
  const response = await apiClient.post(
    "/crime-reference/evidences/",
    evidence
  );
  return response.data;
};
export const editEvidence = async (evidence: Evidence) => {
  const response = await apiClient.put(
    "/crime-reference/evidences/" + evidence?.uu_id + "/",
    evidence
  );
  return response.data;
};
export const deleteEvidence = async (evidence: Evidence) => {
  const response = await apiClient.delete(
    "/crime-reference/evidences/" + evidence?.uu_id + "/"
  );
  return response.data;
};

// EXHIBIT
export const fetchExhibit = async () => {
  const response = await apiClient.get<Exhibit[]>("/crime-reference/exhibits/");
  return response.data;
};
export const addExhibit = async (exhibit: Exhibit) => {
  const response = await apiClient.post("/crime-reference/exhibits/", exhibit);
  return response.data;
};
export const editExhibit = async (exhibit: Exhibit) => {
  const response = await apiClient.put(
    "/crime-reference/exhibits/" + exhibit?.uu_id + "/",
    exhibit
  );
  return response.data;
};
export const deleteExhibit = async (exhibit: Exhibit) => {
  const response = await apiClient.delete(
    "/crime-reference/exhibits/" + exhibit?.uu_id + "/"
  );
  return response.data;
};

